import { ChangeDetectorRef, Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';

import { Modal } from 'bootstrap';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InfoboxService } from './infobox.service';

interface InfoboxQueue {
	type: string;
	style: string;
	icon: string;
	text: string;
}

@Component({
	selector: 'app-infobox',
	templateUrl: './infobox.component.html',
	styleUrls: ['./infobox.component.css'],
})
export class InfoboxComponent implements OnInit, OnDestroy {
	icon = '';
	queue: Array<InfoboxQueue> = [];
	private readonly icons = {
		success: ['fas fa-check-square'],
		error: ['fas fa-times'],
		warning: ['fas fa-exclamation-triangle'],
	};

	constructor(
		private readonly infoboxService: InfoboxService,
		private readonly cdr: ChangeDetectorRef,
		private readonly destroyRef: DestroyRef,
	) {}

	ngOnInit(): void {
		this.infoboxService.infobox.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			if (this.queue.length && this.queue[0].text == data.text) {
				return;
			}
			if (!data) {
				return;
			}
			this.queue.push(data);
			if (this.queue.length == 1) {
				this.checkQueue();
			}
		});
	}

	ngOnDestroy(): void {
		this.close();
	}

	private checkQueue(): void {
		if (!this.queue.length) {
			return;
		}
		switch (this.queue[0].type) {
			case 'error':
				this.queue[0].style = 'danger';
				break;
			case 'warning':
				this.queue[0].style = 'warning';
				break;
			default:
				this.queue[0].style = this.queue[0].type;
				break;
		}
		this.queue[0].icon = this.randomIcon(this.queue[0].type);
		new Modal(document.getElementById('infoboxModal')).show();
		this.cdr.detectChanges();
	}

	close(): void {
		const modal = Modal.getInstance(document.getElementById('infoboxModal'));
		if (!modal) {
			return;
		}
		modal.hide();
		this.queue.shift();
		this.checkQueue();
	}

	private randomIcon(type: string): string {
		if (!type || this.icons[type] === undefined) {
			return '';
		}
		return this.icons[type][Math.floor(Math.random() * this.icons[type].length)];
	}
}
